import { api } from '@/constants'
import { getAuthHeader, serializeQueryParams } from '@/util'
import baseURL from '@/service/api'

const order = {
  orders: params => {
    const url = api.order.list + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  tempOrderList: params => {
    const url = api.order.tempOrderList + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  uploadOrder: payloads => {
    const url = api.order.uploadOrder
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  createMultipleOrder: payloads => {
    const url = api.order.createMultipleOrder
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  tempOrderDetail: tempOrderId => {
    const url = api.order.tempOrderDetail(tempOrderId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  updateTempOrder: (tempOrderId, payloads) => {
    const url = api.order.tempOrderDetail(tempOrderId)
    return baseURL.patch(url, payloads, { headers: getAuthHeader() })
  },
  deleteTempOrder: tempOrderId => {
    const url = api.order.tempOrderDetail(tempOrderId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },
  orderDetail: orderId => {
    const url = api.order.detail(orderId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  processOrder: orderId => {
    const url = api.order.processOrder(orderId)
    return baseURL.post(url, {}, { headers: getAuthHeader() })
  },
  rejectOrder: (orderId, payloads) => {
    const url = api.order.rejectOrder(orderId)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  retry: orderId => {
    const url = api.order.retry(orderId)
    return baseURL.post(url, {}, { headers: getAuthHeader() })
  },
  downloadShippingLabel: orderId => {
    const url = api.order.downloadShippingLabel(orderId)
    return baseURL.post(url, { user_type: process.env.VUE_APP_USER_TYPE }, { headers: getAuthHeader(), responseType: 'blob' })
  },
  complain: (orderId, payloads) => {
    const url = api.order.complain(orderId)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  cancelOrder: (orderId, reason) => {
    const url = api.order.cancel(orderId)
    return baseURL.post(url, { reason: reason }, { headers: getAuthHeader() })
  },
  getDraftOrders: params => {
    const url = api.order.draftOrder + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  countDraftOrders: () => {
    const url = api.order.draftOrderCount
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  draftOrderDetail: draftOrderId => {
    const url = api.order.draftOrderDetail(draftOrderId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createDraftOrder: payloads => {
    const url = api.order.draftOrder
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  deleteDraftOrder: draftOrderId => {
    const url = api.order.draftOrderDetail(draftOrderId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },
  updateDraftOrder: (draftOrderId, payloads) => {
    const url = api.order.draftOrderDetail(draftOrderId)
    return baseURL.patch(url, payloads, { headers: getAuthHeader() })
  },
  updatePriceAdjustmentStatus: (orderId, payloads) => {
    const url = api.order.priceAdjustment(orderId)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  }
}
export default order
